import {
  Alert,
  Card,
  Form,
  FormButton,
  FormFeedback,
  FormProps,
  Input,
  UserAvatar,
  message,
} from 'admin-web-ui'
import gql from 'graphql-tag'
import { Store } from 'rc-field-form/lib/interface'
import React, { useMemo } from 'react'
import { useAsyncFn } from 'react-use'
import styled from 'styled-components'
import { useConsoleContext } from '../../containers/Console'

const TypedForm: React.FC<FormProps> = (props) => <Form {...props} />
const StyledForm = styled(TypedForm)`
  width: 400px;
`

const Section = styled.div`
  margin-bottom: 24px;
`

export const UPDATE_ME = gql`
  mutation updateProfile($firstName: String, $lastName: String) {
    updateProfile(firstName: $firstName, lastName: $lastName)
  }
`

export interface FormData {
  firstName: string
  lastName: string
}

export const EditProfileForm = (): JSX.Element => {
  const { me, refreshData, customerClient } = useConsoleContext()

  const initialFormData = useMemo<FormData>(
    () => ({
      firstName: me.firstName ?? '',
      lastName: me.lastName ?? '',
    }),
    [me],
  )

  const [submitState, submit] = useAsyncFn(
    async (store?: Store) => {
      if (!store) {
        return undefined
      }

      const formData = store as FormData

      await customerClient.mutate({
        mutation: UPDATE_ME,
        variables: {
          firstName: formData.firstName,
          lastName: formData.lastName,
        },
      })

      await refreshData()

      message.success('Your profile was updated')
    },
    [customerClient],
  )

  return (
    <Card>
      <Section>
        <h4>Profile Avatar</h4>
        <UserAvatar type="primary" hideDisplayName userInfo={me} />
      </Section>
      <Section>
        <h4>Email</h4>
        <p id="edit-profile-form__user-email">{me.emailAddress}</p>
      </Section>
      <StyledForm onFinish={submit} initialValues={initialFormData}>
        <Form.Item label="First name" name="firstName">
          <Input placeholder="First Name" />
        </Form.Item>
        <Form.Item label="Last name" name="lastName">
          <Input placeholder="Last Name" />
        </Form.Item>
        <FormFeedback showText={!!submitState.error}>
          <Alert
            type="error"
            message="There was an error saving your information. Please try agian."
          />
        </FormFeedback>
        <FormButton.Submit loading={submitState.loading}>
          Save
        </FormButton.Submit>
      </StyledForm>
    </Card>
  )
}
